'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getQueryKey = undefined;

var _jsonStableStringify = require('json-stable-stringify');

var _jsonStableStringify2 = _interopRequireDefault(_jsonStableStringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getQueryKey = exports.getQueryKey = function getQueryKey(_ref) {
    var url = _ref.url,
        body = _ref.body,
        queryKey = _ref.queryKey;

    if (queryKey !== null && queryKey !== undefined) {
        return queryKey;
    } else {
        return (0, _jsonStableStringify2.default)({ url: url, body: body });
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-query/dist/commonjs/lib/query-key.js
 ** module id = 305
 ** module chunks = 3
 **/